// Winamp Playlist — Organised by Genre & Artist
// Local files served from public/music/
// Radio streams kept at the top

export const initialTracks = [
  // =============================================
  // LIVE RADIO STREAMS
  // (Streams are infinite-length — no duration)
  // =============================================
  {
    url: 'https://dnbradio.nl/dnbradio_main.mp3',
    metaData: { title: 'DNB Radio', artist: 'dnbradio.nl', album: 'Live Radio' },
  },
  {
    url: 'https://ice.bassdrive.net/stream32',
    metaData: { title: 'Bassdrive', artist: 'bassdrive.com', album: 'Live Radio' },
  },
  {
    url: 'https://radiott-web.streaming-pro.com:6103/radiott.mp3',
    metaData: { title: 'Radio TT', artist: 'Radio TT', album: 'Live Radio' },
  },

  // =============================================
  // CLASSIC ROCK — Eagles
  // =============================================
  {
    url: '/music/Classic Rock/Eagles/01 - Hotel California (Eagles 2013 Remaster).mp3',
    duration: 391,
    metaData: { title: 'Hotel California', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/02 - New Kid in Town (Eagles 2013 Remaster).mp3',
    duration: 304,
    metaData: { title: 'New Kid in Town', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/03 - Life in the Fast Lane (Eagles 2013 Remaster) [Explicit].mp3',
    duration: 286,
    metaData: { title: 'Life in the Fast Lane', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/04 - Wasted Time (Eagles 2013 Remaster).mp3',
    duration: 296,
    metaData: { title: 'Wasted Time', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/05 - Wasted Time (Reprise) [Eagles 2013 Remaster].mp3',
    duration: 83,
    metaData: { title: 'Wasted Time (Reprise)', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/06 - Victim of Love (Eagles 2013 Remaster).mp3',
    duration: 250,
    metaData: { title: 'Victim of Love', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/07 - Pretty Maids All in a Row (Eagles 2013 Remaster).mp3',
    duration: 239,
    metaData: { title: 'Pretty Maids All in a Row', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/08 - Try and Love Again (Eagles 2013 Remaster).mp3',
    duration: 311,
    metaData: { title: 'Try and Love Again', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },
  {
    url: '/music/Classic Rock/Eagles/09 - The Last Resort (Eagles 2013 Remaster) [Explicit].mp3',
    duration: 444,
    metaData: { title: 'The Last Resort', artist: 'Eagles', album: 'Hotel California (Remastered)' },
  },

  // =============================================
  // CLASSIC ROCK — Rainbow
  // =============================================
  {
    url: '/music/Classic Rock/Rainbow/01 All Night Long.mp3',
    duration: 233,
    metaData: { title: 'All Night Long', artist: 'Rainbow', album: 'Rainbow Greatest Hits' },
  },
  {
    url: '/music/Classic Rock/Rainbow/02 Catch The Rainbow.mp3',
    duration: 398,
    metaData: { title: 'Catch The Rainbow', artist: 'Rainbow', album: 'Ritchie Blackmore\'s Rainbow' },
  },
  {
    url: "/music/Classic Rock/Rainbow/03 Since You've Been Gone.mp3",
    duration: 199,
    metaData: { title: "Since You've Been Gone", artist: 'Rainbow', album: 'Down to Earth' },
  },
  {
    url: '/music/Classic Rock/Rainbow/04 I Surrender.mp3',
    duration: 244,
    metaData: { title: 'I Surrender', artist: 'Rainbow', album: 'Difficult to Cure' },
  },
  {
    url: '/music/Classic Rock/Rainbow/05 Stone Cold.mp3',
    duration: 319,
    metaData: { title: 'Stone Cold', artist: 'Rainbow', album: 'Straight Between the Eyes' },
  },
  {
    url: '/music/Classic Rock/Rainbow/06 Kill The King.mp3',
    duration: 270,
    metaData: { title: 'Kill The King', artist: 'Rainbow', album: 'Long Live Rock \'n\' Roll' },
  },
  {
    url: '/music/Classic Rock/Rainbow/07 Stargazer.mp3',
    duration: 508,
    metaData: { title: 'Stargazer', artist: 'Rainbow', album: 'Rising' },
  },
  {
    url: '/music/Classic Rock/Rainbow/08 Starstruck.mp3',
    duration: 248,
    metaData: { title: 'Starstruck', artist: 'Rainbow', album: 'Rising' },
  },
  {
    url: '/music/Classic Rock/Rainbow/09 Sixteenth Century Greensleeves.mp3',
    duration: 455,
    metaData: { title: 'Sixteenth Century Greensleeves', artist: 'Rainbow', album: 'Rising' },
  },
  {
    url: '/music/Classic Rock/Rainbow/10 Man On The Silver Mountain.mp3',
    duration: 278,
    metaData: { title: 'Man On The Silver Mountain', artist: 'Rainbow', album: 'Ritchie Blackmore\'s Rainbow' },
  },
  {
    url: "/music/Classic Rock/Rainbow/11 Long Live Rock 'N' Roll.mp3",
    duration: 262,
    metaData: { title: "Long Live Rock 'N' Roll", artist: 'Rainbow', album: "Long Live Rock 'n' Roll" },
  },
  {
    url: '/music/Classic Rock/Rainbow/12 Run With The Wolf.mp3',
    duration: 222,
    metaData: { title: 'Run With The Wolf', artist: 'Rainbow', album: "Long Live Rock 'n' Roll" },
  },
  {
    url: '/music/Classic Rock/Rainbow/13 Lost In Hollywood.mp3',
    duration: 294,
    metaData: { title: 'Lost In Hollywood', artist: 'Rainbow', album: 'Rising' },
  },
  {
    url: "/music/Classic Rock/Rainbow/14 If You Don't Like Rock 'N' Roll.mp3",
    duration: 158,
    metaData: { title: "If You Don't Like Rock 'N' Roll", artist: 'Rainbow', album: "Long Live Rock 'n' Roll" },
  },
  {
    url: '/music/Classic Rock/Rainbow/15 Miss Mistreated.mp3',
    duration: 268,
    metaData: { title: 'Miss Mistreated', artist: 'Rainbow', album: 'Difficult to Cure' },
  },
  {
    url: '/music/Classic Rock/Rainbow/16 Death Alley Driver.mp3',
    duration: 285,
    metaData: { title: 'Death Alley Driver', artist: 'Rainbow', album: 'Straight Between the Eyes' },
  },

  // =============================================
  // CLASSIC ROCK — AC/DC
  // =============================================
  {
    url: '/music/Classic Rock/AC-DC/01 You Shook Me All Night Long.mp3',
    duration: 224,
    metaData: { title: 'You Shook Me All Night Long', artist: 'AC/DC', album: 'Back in Black' },
  },
  {
    url: '/music/Classic Rock/AC-DC/07 You Shook Me All Night Long.mp3',
    duration: 210,
    metaData: { title: 'You Shook Me All Night Long (Live)', artist: 'AC/DC', album: 'Live' },
  },
  {
    url: '/music/Classic Rock/AC-DC/01 - For Those About to Rock (We Salute You).mp3',
    duration: 344,
    metaData: { title: 'For Those About to Rock', artist: 'AC/DC', album: 'For Those About to Rock' },
  },
  {
    url: '/music/Classic Rock/AC-DC/02 Soap On A Rope.mp3',
    duration: 333,
    metaData: { title: 'Soap On A Rope', artist: 'Chickenfoot', album: 'Chickenfoot' },
  },

  // =============================================
  // CLASSIC ROCK — Deep Purple
  // =============================================
  {
    url: '/music/Classic Rock/Deep Purple/01 Smoke On The Water.mp3',
    duration: 347,
    metaData: { title: 'Smoke On The Water', artist: 'Deep Purple', album: 'Machine Head' },
  },
  {
    url: '/music/Classic Rock/Deep Purple/05 Smoke on the Water.mp3',
    duration: 341,
    metaData: { title: 'Smoke on the Water (Live)', artist: 'Deep Purple', album: 'Made in Japan' },
  },

  // =============================================
  // CLASSIC ROCK — Cream
  // =============================================
  {
    url: '/music/Classic Rock/Cream/01 Sunshine Of Your Love.mp3',
    duration: 290,
    metaData: { title: 'Sunshine Of Your Love', artist: 'Cream', album: 'Disraeli Gears' },
  },
  {
    url: '/music/Classic Rock/Cream/15 Sunshine Of Your Love.mp3',
    duration: 253,
    metaData: { title: 'Sunshine Of Your Love (Live)', artist: 'Cream', album: 'Live' },
  },

  // =============================================
  // CLASSIC ROCK — Guns N' Roses
  // =============================================
  {
    url: "/music/Classic Rock/Guns N Roses/09 Sweet Child O' Mine.mp3",
    duration: 356,
    metaData: { title: "Sweet Child O' Mine", artist: "Guns N' Roses", album: 'Appetite for Destruction' },
  },

  // =============================================
  // CLASSIC ROCK — Pink Floyd
  // =============================================
  {
    url: '/music/Classic Rock/Pink Floyd/(Disc 2) 06 - Comfortably Numb (2011 Remastered Version).mp3',
    duration: 382,
    metaData: { title: 'Comfortably Numb', artist: 'Pink Floyd', album: 'The Wall (Remastered)' },
  },

  // =============================================
  // CLASSIC ROCK — The Beatles
  // =============================================
  {
    url: '/music/Classic Rock/The Beatles/11 Blackbird.mp3',
    duration: 137,
    metaData: { title: 'Blackbird', artist: 'The Beatles', album: 'The White Album' },
  },

  // =============================================
  // CLASSIC ROCK — Genesis
  // =============================================
  {
    url: '/music/Classic Rock/Genesis/06 - Mama.mp3',
    duration: 314,
    metaData: { title: 'Mama', artist: 'Genesis', album: 'Genesis' },
  },

  // =============================================
  // CLASSIC ROCK — The Style Council
  // =============================================
  {
    url: '/music/Classic Rock/The Style Council/11 But, Honestly.mp3',
    duration: 275,
    metaData: { title: 'But Honestly', artist: 'The Style Council', album: 'Our Favourite Shop' },
  },
  {
    url: "/music/Classic Rock/The Style Council/17 You're the Best Thing.mp3",
    duration: 264,
    metaData: { title: "You're the Best Thing", artist: 'The Style Council', album: 'Our Favourite Shop' },
  },

  // =============================================
  // METAL — Metallica
  // =============================================
  {
    url: '/music/Metal/Metallica/01 Enter Sandman 2.mp3',
    duration: 330,
    metaData: { title: 'Enter Sandman', artist: 'Metallica', album: 'Metallica (Black Album)' },
  },

  // =============================================
  // METAL — Ozzy Osbourne
  // =============================================
  {
    url: '/music/Metal/Ozzy Osbourne/02 Crazy Train.mp3',
    duration: 290,
    metaData: { title: 'Crazy Train', artist: 'Ozzy Osbourne', album: 'Blizzard of Ozz' },
  },

  // =============================================
  // METAL — Linkin Park
  // =============================================
  {
    url: '/music/Metal/Linkin Park/04 Bleed It Out.mp3',
    duration: 163,
    metaData: { title: 'Bleed It Out', artist: 'Linkin Park', album: 'Minutes to Midnight' },
  },

  // =============================================
  // ROCK — Muse
  // =============================================
  {
    url: '/music/Rock/Muse/03 Supermassive Black Hole.mp3',
    duration: 208,
    metaData: { title: 'Supermassive Black Hole', artist: 'Muse', album: 'Black Holes and Revelations' },
  },

  // =============================================
  // ROCK — Toto
  // =============================================
  {
    url: '/music/Rock/Toto/01 - Hydra.mp3',
    duration: 451,
    metaData: { title: 'Hydra', artist: 'Toto', album: 'Hydra' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 01 - Rosanna.mp3',
    duration: 329,
    metaData: { title: 'Rosanna', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 02 - Make Believe.mp3',
    duration: 222,
    metaData: { title: 'Make Believe', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: "/music/Rock/Toto/(Disc 2) 03 - I Won't Hold You Back.mp3",
    duration: 294,
    metaData: { title: "I Won't Hold You Back", artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 04 - Good for You.mp3',
    duration: 197,
    metaData: { title: 'Good for You', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: "/music/Rock/Toto/(Disc 2) 05 - It's a Feeling.mp3",
    duration: 185,
    metaData: { title: "It's a Feeling", artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 06 - Afraid of Love.mp3',
    duration: 232,
    metaData: { title: 'Afraid of Love', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 07 - Lovers in the Night.mp3',
    duration: 265,
    metaData: { title: 'Lovers in the Night', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 08 - We Made It.mp3',
    duration: 236,
    metaData: { title: 'We Made It', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 09 - Waiting for Your Love.mp3',
    duration: 252,
    metaData: { title: 'Waiting for Your Love', artist: 'Toto', album: 'Toto IV' },
  },
  {
    url: '/music/Rock/Toto/(Disc 2) 10 - Africa.mp3',
    duration: 295,
    metaData: { title: 'Africa', artist: 'Toto', album: 'Toto IV' },
  },

  // =============================================
  // GUITAR VIRTUOSO — Joe Satriani
  // =============================================
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/02 - St. George and the Dragon.mp3',
    duration: 284,
    metaData: { title: 'St. George and the Dragon', artist: 'Joe Satriani', album: 'Surfing with the Alien' },
  },
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/03 - 99.mp3',
    duration: 314,
    metaData: { title: '99', artist: 'Joe Satriani', album: 'Not of This Earth' },
  },
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/04 - Satch Boogie.mp3',
    duration: 192,
    metaData: { title: 'Satch Boogie', artist: 'Joe Satriani', album: 'Surfing with the Alien' },
  },
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/04 - Lorraine.mp3',
    duration: 286,
    metaData: { title: 'Lorraine', artist: 'Joe Satriani', album: 'Flying in a Blue Dream' },
  },
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/05 - All Us Boys.mp3',
    duration: 300,
    metaData: { title: 'All Us Boys', artist: 'Joe Satriani', album: 'Not of This Earth' },
  },
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/07 - White Sister.mp3',
    duration: 339,
    metaData: { title: 'White Sister', artist: 'Joe Satriani', album: 'Not of This Earth' },
  },
  {
    url: '/music/Guitar Virtuoso/Joe Satriani/08 - A Secret Love.mp3',
    duration: 188,
    metaData: { title: 'A Secret Love', artist: 'Joe Satriani', album: 'Not of This Earth' },
  },

  // =============================================
  // GUITAR VIRTUOSO — Planet X
  // =============================================
  {
    url: '/music/Guitar Virtuoso/Planet X/01 Alien Hip Hop.mp3',
    duration: 432,
    metaData: { title: 'Alien Hip Hop', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/02 Desert Girl.mp3',
    duration: 365,
    metaData: { title: 'Desert Girl', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/03 Matrix Gate.mp3',
    duration: 249,
    metaData: { title: 'Matrix Gate', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/04 The Thinking Stone.mp3',
    duration: 253,
    metaData: { title: 'The Thinking Stone', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/05 Space Foam.mp3',
    duration: 285,
    metaData: { title: 'Space Foam', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/06 Poland.mp3',
    duration: 322,
    metaData: { title: 'Poland', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/07 Snuff.mp3',
    duration: 298,
    metaData: { title: 'Snuff', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/08 Kingdom of Dreams.mp3',
    duration: 407,
    metaData: { title: 'Kingdom of Dreams', artist: 'Planet X', album: 'Quantum' },
  },
  {
    url: '/music/Guitar Virtuoso/Planet X/09 Quantum Factor.mp3',
    duration: 428,
    metaData: { title: 'Quantum Factor', artist: 'Planet X', album: 'Quantum' },
  },

  // =============================================
  // OLD SCHOOL MEMES (Easter Eggs)
  // =============================================
  {
    url: 'https://ia800503.us.archive.org/11/items/NeverGonnaGiveYouUp/jocofullinterview41.mp3',
    duration: 212,
    metaData: { title: 'Never Gonna Give You Up', artist: 'Rick Astley', album: 'Old School Memes' },
  },
  {
    url: 'https://ia801002.us.archive.org/18/items/NyanCat1Hour/Nyan%20Cat%20%5Boriginal%5D.mp3',
    duration: 217,
    metaData: { title: 'Nyan Cat', artist: 'daniwell', album: 'Old School Memes' },
  },

  // =============================================
  // DnB (Internet Archive)
  // =============================================
  {
    url: 'https://ia800500.us.archive.org/15/items/DnbLodz/01_-_Electrosoul_System_-_Emotions.mp3',
    duration: 360,
    metaData: { title: 'Emotions', artist: 'Electrosoul System', album: 'DnB Lodz' },
  },
  {
    url: 'https://ia800500.us.archive.org/15/items/DnbLodz/02_-_Electrosoul_System_-_Sunshine.mp3',
    duration: 340,
    metaData: { title: 'Sunshine', artist: 'Electrosoul System', album: 'DnB Lodz' },
  },
  {
    url: 'https://ia800500.us.archive.org/15/items/DnbLodz/03_-_Electrosoul_System_-_Morning_Star.mp3',
    duration: 355,
    metaData: { title: 'Morning Star', artist: 'Electrosoul System', album: 'DnB Lodz' },
  },
];
